import { endpoints } from "@/lib/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const enablePush = async ({ silent = false } = {}) => {
  if (!pushSupported()) throw new Error("Push notifications aren't supported on this device/browser.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications permission was not granted.");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await endpoints.pushVapidPublic();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  if (localStorage.getItem("bbk_token")) await endpoints.pushSubscribe(sub.toJSON(), navigator.userAgent);
  else await endpoints.pushSubscribeGuest({ subscription: sub.toJSON(), ua: navigator.userAgent });
  if (!silent) endpoints.pushTestMe(sub.endpoint).catch(() => {});
  return true;
};

export const isIosBrowserTab = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.matchMedia("(display-mode: standalone)").matches && !window.navigator.standalone;

export const disablePush = async () => {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await endpoints.pushUnsubscribe(sub.endpoint).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
};
